<template>
  <section id="lp-dashboard">
    <admin_dashboard/> 
  </section>
</template>

<script>
import admin_dashboard from "./dashboard/AdminDashboard.vue";
import { decrypt } from "@/utils/crypto";

export default {
  components: {
    admin_dashboard, 
  },
  data() {
    return {
      userData: decrypt(localStorage.getItem("userData")),
    };
  },

  created() {},
};
</script>

